/**
 * Kleine Status-Pill: farbiger Badge mit Status-Text.
 * Wird in Tabellen für entwurf/geplant/abgeschlossen/storniert genutzt.
 */

type Variant = "neutral" | "info" | "success" | "warning" | "danger";
export type { Variant };

const STYLES: Record<Variant, string> = {
  neutral: "bg-slate-100 text-slate-700 border-slate-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  danger: "bg-rose-50 text-rose-700 border-rose-200",
};

const SESSION_STATUS_VARIANT: Record<string, Variant> = {
  entwurf: "neutral",
  geplant: "info",
  abgeschlossen: "success",
  storniert: "danger",
};

const SESSION_STATUS_LABEL: Record<string, string> = {
  entwurf: "Entwurf",
  geplant: "Geplant",
  abgeschlossen: "Abgeschlossen",
  storniert: "Storniert",
};

export function Badge({
  variant = "neutral",
  children,
}: {
  variant?: Variant;
  children: React.ReactNode;
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${STYLES[variant]}`}
    >
      {children}
    </span>
  );
}

export function SessionStatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={SESSION_STATUS_VARIANT[status] ?? "neutral"}>
      {SESSION_STATUS_LABEL[status] ?? status}
    </Badge>
  );
}

export { SESSION_STATUS_LABEL };
